// extracted by mini-css-extract-plugin
module.exports = {"test-label":"test-label__1-YF_"};